import React from 'react';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';
import PropTypes from 'prop-types';
import { ErrorMessage } from '~/components/Form/styles';
import * as S from './styles';

export default function Captcha({ onVerify, captchaError }) {
  return (
    <S.Container>
      <GoogleReCaptcha onVerify={onVerify} />
      <ErrorMessage shouldShow={captchaError !== ''}>
        {captchaError !== '' && captchaError}
      </ErrorMessage>
    </S.Container>
  );
}

Captcha.propTypes = {
  onVerify: PropTypes.func.isRequired,
  captchaError: PropTypes.string,
};
Captcha.defaultProps = {
  captchaError: '',
};
